import { Component, Input, OnInit } from '@angular/core';
import { ApiShow } from '@tytapp/api';
import { PodcastComponent } from '@tytapp/app/podcast/podcast.component';
import { Shell } from '@tytapp/common';
import { UserService } from '@tytapp/user';

@Component({
  selector: 'tyt-podcast-item',
  templateUrl: './podcast-item.component.html',
  styleUrls: ['./podcast-item.component.scss']
})
export class PodcastItemComponent implements OnInit {
  constructor (
    private shell : Shell,
    private userService: UserService
  ) {
  }

  @Input()
  show;

  audienceType = 'visitor';

  subscribed = false;

  showAlteredView = false;
  showTuneInPlatforms = false;

  rssFeedText = '';

  ngOnInit () {
    this.audienceType = this.userService.audienceType;

    if(this.show.tune_ins) {
      var podcastAvailable = this.show.tune_ins.find(item => item.type === 'podcast');
      this.showTuneInPlatforms = podcastAvailable != undefined && podcastAvailable.destinations && podcastAvailable.destinations.length > 0;
    }

    this.rssFeedText = this.show.is_premium ? 'RSS (MEMBERS ONLY)' : 'RSS (AD FREE, MEMBERS ONLY)';
  }

  showRSS(show : ApiShow) {
    this.shell.showDialog(PodcastComponent, { show });
  }

  get podcastTuneIn() {
    if (!this.show.tune_ins)
      return null;

    return this.show.tune_ins.find(x => x.type === 'podcast');
  }

  toggleAlteredView() {
    this.showAlteredView = !this.showAlteredView;
  }
}
